export const AO = "0syT13r0s0tgPmIed95bJnuSqaD29HQNN8D3ElLSrsc"
export const PI = "4hXj_E-5fAKmo4E8KjgQvuDJKAFk9P2grhycVmISDLs"
export const wAR = "xU9zFkq3X2ZQ6olwNVvr1vUWIjc3kXTWr7xKQD6dh10"
export const wUSDC = "7zH9dlMNoxprab9loshv3Y7WG45DOny_Vrq9KrXObdQ"

const HB_ROUTES = {
  forward: "https://state.forward.computer",
  af: "https://hb.zoao.dev",
  arweaveAsia: "https://hb.arweave.asia",
}

export const getHBBaseUrlInternal = (process: string) => {
  if ([AO].includes(process)) {
    return HB_ROUTES.forward
  }

  if ([wAR, wUSDC].includes(process)) {
    return HB_ROUTES.arweaveAsia
  }

  return HB_ROUTES.af
}
const PUSH_ROUTES = {
  push1: "https://push-1.forward.computer",
  push3: "https://push-3.forward.computer",
  push4: "https://push-4.forward.computer",
  push5: "https://push-5.forward.computer",
  state2: "https://state-2.forward.computer",
}

const PROCESS_TO_ROUTE: Record<string, string> = {
  // Pools on push nodes
  "B6qAwHi2OjZmyFCEU8hV6FZDSHbAOz8r0yy-fBbuTus": PUSH_ROUTES.push5,
  "cfJIBVw4ojWnjiQJ1Z6CRU56YnYJPZpaMgAIs-BSi68": PUSH_ROUTES.push4,
  Bv5mfnx5Ln2BU60inXPnMOGMwecJXadV4oqw7iwjzSk: PUSH_ROUTES.push5,
  "9JgTfmz0d32tRSp4Z5ZNQygAPoDjWfEvdiWRsx4ECWU": PUSH_ROUTES.push5,
  "6Pi7o68Bl6NYvr0nAkJHgEerT7vEbIiDwvk1BMFDhzk": PUSH_ROUTES.push5,
  wTIpisZKMtG5WsLFqQBdoJEObyyeoJQmwWFm1h462D4: PUSH_ROUTES.push5,
  "WuAkqYvunUtsD8uvpsK9XtR7_5-fbnH3ATD4DJrl-Ac": PUSH_ROUTES.push5,
  aDeXXVoY5bYWk2k5SFK9bSIxDFw1M9d2ac2vRZEnW7s: PUSH_ROUTES.push3,
  // Tokens on state-2
  uEqh7GDRNsn4izN95zdwIdUULwnG35it8B7C7EIjZfc: PUSH_ROUTES.state2,
  Zb5PFBVRiTo0Q7h7edGGsrXpDovAyAXAipEgYeB2tIc: PUSH_ROUTES.state2,
  "eFlMR-9TPoaLZHbXaiCOlZovj1GWDojZ3xNQxrSVLL0": PUSH_ROUTES.state2,
  n2MhPK0O3yEvY2zW73sqcmWqDktJxAifJDrri4qireI: PUSH_ROUTES.state2,
  "gx_jKk-hy8-sB4Wv5WEuvTTVyIRWW3We7rRHthcohBQ": PUSH_ROUTES.state2,
  "K59Wi9uKXBQfTn3zw7L_t-lwHAoq3Fx-V9sCyOY3dFE": PUSH_ROUTES.state2,
  //"s6jcB3ctSbiDNwR-paJgy5iOAhahXahLul8exSLHbGE": PUSH_ROUTES.state2,
  "oX5gh0j-DNHUvolnujWqKRcrrna1e-dsyy6CAjqGtBc": PUSH_ROUTES.state2,
  "Jc2bcfEbwHFQ-qY4jqm8L5hc-SggeVA1zlW6DOICWgo": PUSH_ROUTES.state2,
  "DM3FoZUq_yebASPhgd8pEIRIzDW6muXEhxz5-JwbZwo": PUSH_ROUTES.state2,
  // ARIO on push-1
  qNvAoz0TgcH7DMg8BCVn8jF32QH5L6T29VjHxhHqqGE: PUSH_ROUTES.push1,
}

export const getHBBaseUrl = (process: string) => {
  if (PROCESS_TO_ROUTE[process]) {
    return PROCESS_TO_ROUTE[process]
  }
  return getHBBaseUrlInternal(process)
}
